import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MtcTypeModel } from './mtcType.model';
import { environment } from '../../../../environments/environment';
import { catchError, map, Observable } from 'rxjs';

const API_URL = environment.apiUrl
@Injectable({
  providedIn: 'root'
})
export class MtcTypeService {

  constructor(private http: HttpClient) {}

  addMtcType(mtctype: MtcTypeModel) {
    
    return this.http.post(API_URL + '/MtcType/CreateMtcType', mtctype, {
      withCredentials: true,
    }).pipe(
      map((response: any) => {
        return response
      }),
      catchError((error: any) => {
        

        throw new HttpErrorResponse({
          status: error.error.statusCode,
          statusText: error.error.response,
        })
      }),
    )
  }

  updateMtcType(mtctype: MtcTypeModel) {
    
    return this.http.put(API_URL + '/MtcType/UpdateMtcType', mtctype, {
      withCredentials: true,
    }).pipe(
      map((response: any) => {
        return response
      }),
      catchError((error: any) => {
        

        throw new HttpErrorResponse({
          status: error.error.statusCode,
          statusText: error.error.response,
        })
      }),
    )
  }

  getAllMtcTypes(): Observable<MtcTypeModel[]> {
    return this.http.get(API_URL + '/MtcType/ReadMtcTypes', {
      withCredentials: true,
    }).pipe(
      map((response: any) => {
        return response
      }),
      catchError((error: any) => {
        

        throw new HttpErrorResponse({
          status: error.error.statusCode,
          statusText: error.error.response,
        })
      }),
    )
  }


  deleteMtcType(mtctype: MtcTypeModel) {
    
    return this.http.delete(API_URL + '/MtcType/DeleteMtcType',  {
      headers: {},
      body: mtctype,
      withCredentials: true
   }).pipe(
      map((response: any) => {
        return response
      }),
      catchError((error: any) => {
        

        throw new HttpErrorResponse({
          status: error.error.statusCode,
          statusText: error.error.response,
        })
      }),
    )
  }


}
